import React, {Component} from "react";
import styles from "./Breadcrumb.module.scss";
import CodeLabel from "components/codeLabel/CodeLabel";
import {Context} from "context";

export default class Breadcrumb extends Component {
    static contextType = Context;

    render() {
        const selectedWindow = this.context.windows.find(window => window.mapId === this.props.selectedMapId);
        const folder = this.context.folderStructure.find(folder => folder.codeNames.some(map => map.id === this.props.selectedMapId))
        const map = folder?.codeNames.find(map => map.id === this.props.selectedMapId);
        const title = selectedWindow && folder?.title.split(":")[0];
        const folderGroupNameCapitalised = folder?.groupName.charAt(0).toUpperCase() + folder?.groupName.slice(1);

        return (
            <div className={`highlightSecondary ${styles.breadcrumb}`} data-hint={this.context.text.hints.breadcrumb}>
                {
                    selectedWindow ?
                    <>
                        <div className={`bgSecondary ${styles.crumb}`}>
                            <span className={`txtSecondary ${styles.descriptor}`}>Group:</span>
                            <CodeLabel className={folder?.groupName} code={folderGroupNameCapitalised}/>
                        </div>
                        <div className={`highlightPrimary ${styles.crumb}`}>
                            <span className={`txtSecondary ${styles.descriptor}`}>Folder:</span>
                            <CodeLabel className="ungrouped" code={title}/>
                        </div>
                        <div className={`highlightPrimary ${styles.crumb}`}>
                            <span className={`txtSecondary ${styles.descriptor}`}>Map:</span>
                            <CodeLabel className="ungrouped" code={map?.title}/>
                        </div>
                        { selectedWindow.axisEditingAxisName &&
                            <div className={`highlightPrimary ${styles.crumb}`}>
                                <span className={`txtSecondary ${styles.descriptor}`}>{`${selectedWindow.axisEditingAxisName.toUpperCase()}:`}</span>
                                <CodeLabel className="ungrouped" code={"a"}/>
                            </div>
                        }
                    </>
                        :
                    null
                }
            </div>
        );
    }

}